import { FaArrowRight } from "react-icons/fa6"
import { useSelector } from "react-redux"
import { DecodeHtml } from "../../utils/decodeHtml"
import { Link } from "react-router-dom"
import { retrunAssets } from "../../utils/getAssets"


const HallOfFrame = () => {



    const state = useSelector(state => state.aboutUnitenContent)



    const aboutUniten = state?.data?.properties

    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })
    const alumniPictures = aboutUniten?.alumniPictures?.map((img) => retrunAssets(img.url))

    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            <p className='w-auto whitespace-pre-line'>{description}</p>

            {/* <p className="w-auto text-[#071946B2] text-justify   text-base font-normal leading-normal">{`Since 1998, the university has produced 30,874 graduates. The role of the university’s graduates are important towards developing and contributing back to the community and nation. Among them, there are those who have achieved big success, locally and internationally, in their own chosen professions. UNITEN is proud to have them as part of the alumni.`}</p> */}
            <Link to="/alumni-relations-career" className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                <span className="text-white text-base font-bold capitalize flex items-center gap-3">See more <FaArrowRight /></span>
            </Link>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {
                    alumniPictures?.map((img, i) => (
                        <img key={i} src={img} className="w-full  bg-gray-100 h-auto object-cover aspect-square bg-center rounded-lg  bg-cover bg-no-repeat italic" alt="photo" />
                    ))
                }
            </div>

        </div>
    )
}

export default HallOfFrame